import React, { Component, Fragment } from 'react'
import '../../styles/Popup.module.css'
import moment from 'moment';
import {
    Modal,
    Select,
    Input,
    Button,
    Upload,
    Row,
    Col,
    Empty,
    Space,
    Table,
    message,
} from 'antd';
import ImgCrop from 'antd-img-crop';
import ReactDropzone from "react-dropzone";
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestServerGet } from '../../actions';

import { DeleteOutlined, EditOutlined, PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import PopupManager from '../../managers/PopupManager';
import ScreenSelectorPopup from './ScreenSelectorPopup';
import CreateSchedultPopup from './CreateSchedulePopup';
const { Option } = Select;

const SCHEDULE_STATUSES = {
    "1": "Scheduled",
    "2": "Finished",
    "3": "Canceled"
}



class PublishingScheduleManagerPage extends Component {
    constructor(props) {
        super(props);
        this.state = { scheduleDatas: [], showCreateSchedule: false, selectedSchedule: null };
    }

    deleteSchedule = (selectedSchedule) => {
        const { requestServerPost, usertoken } = this.props;
        if (selectedSchedule) {
            const params = new FormData();
            params.append("scheduleid", selectedSchedule.ScheduleID)

            requestServerPost("delete_schedule_publish", params, {}, (response) => {
                message.success("The selected schedule has been deleted")
                this.reloadSchedules();
            }, usertoken);
        }
    }

    initiateDelete = (selectedSchedule) => {

        Modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: `Do you want to delete the selected schedule`,
            okText: 'OK',
            cancelText: 'Cancel',
            onOk: () => this.deleteSchedule(selectedSchedule)
        });
    }

    getColumns = () => {
        const { requestServerGet, usertoken, selectedBrandData, screendata = null } = this.props;
        return [
            {
                title: 'Schedule',
                dataIndex: 'ExecuteTime',
                align: "left",
                key: 'ExecuteTime',
                width: 118,
                render: (text) => {
                    const [date, time] = (text || "").split(" ");
                    return (
                        <div>
                            <div style={{ fontSize: 12 }}>{date}</div>
                            <div style={{ fontSize: 11, color: "#94a3b8" }}>{time}</div>
                        </div>
                    );
                },
            },
            {
                title: 'Status',
                dataIndex: 'status',
                align: "center",
                key: 'status',
                width: 76,
                render: (text) => <span style={{ fontSize: 12 }}>{text}</span>,
            },
            {
                title: 'Action',
                key: 'action',
                align: "center",
                width: 64,
                render: (text, record) => (
                    <Space size={2}>
                        <Button title="Edit" size="small" style={{ padding: "0 4px" }} onClick={() => {
                            this.setState({ showCreateSchedule: true, selectedSchedule: record })
                        }} type="link" icon={<EditOutlined />}></Button>
                        <Button title="Delete" size="small" style={{ padding: "0 4px" }} type="link" onClick={() => { this.initiateDelete(record) }} danger icon={<DeleteOutlined />}></Button>
                    </Space>
                ),
            }
        ]
    };


    componentDidMount() {
        this.reloadSchedules();
    }

    reloadSchedules = () => {
        return new Promise((resolve, reject) => {

            const { requestServerGet, usertoken, selectedBrandData, screendata = null } = this.props;

            requestServerGet("get_schedule_publish", { brandid: selectedBrandData.BrandID, branchid: screendata.BranchID }, null, (response) => {


                // console.log("get_defaultlayouttemplates")
                // console.log(JSON.stringify(response.data))

                // this.setState({ defaultTemplateDatas: LayoutTemplates.templates })
                this.setState({ scheduleDatas: response.data }, () => resolve())
            }, usertoken)
        })
    }


    launchCreateSchedule = () => {
        this.setState({ showCreateSchedule: true, selectedSchedule: null })
    }

    handleOk = () => {
        this.setState({ showCreateSchedule: false })
    }

    handleCancel = () => {
        this.setState({ showCreateSchedule: false })
    }

    render() {
        const { screendata = null } = this.props;
        // const previewStyle = {
        //     display: 'inline',
        //     width: 100,
        //     height: 100,
        // };
        return (
            <div className="popupcontentcontainer" style={{ height: "100%", padding: "24px" }}>
                <Row>
                    <Col span={24}>
                        <Space style={{ marginBottom: "24px" }}>
                            <Button type='primary' style={{ borderRadius: "4px" }} icon={<PlusOutlined />} onClick={this.launchCreateSchedule}>Create New Schedule</Button>
                            {/* <Button style={{ borderRadius: "4px" }}>Edit</Button> */}
                        </Space>
                    </Col>
                    <Col span={24}>
                        <div className={`schedule-table-wrapper${this.state.scheduleDatas.length ? '' : ' is-empty'}`}>
                            {this.state.scheduleDatas.length ? <Table dataSource={this.state.scheduleDatas.map((schedule, index) => {
                                schedule.key = index;
                                schedule.status = SCHEDULE_STATUSES[`${schedule.ScheduleStatus}`];
                                return schedule
                            }).filter((scheduleDat) => {
                                return scheduleDat.ScreenID === screendata.ScreenID;
                            }).sort((a, b) => {
                                const aTime = moment(a.ExecuteTime.replace(" ", "T"))
                                const bTime = moment(b.ExecuteTime.replace(" ", "T"))

                                if (bTime.isAfter(aTime))
                                    return -1
                                else
                                    return 1
                            })} columns={this.getColumns()} size="small" pagination={{ size: "small" }} scroll={{ y: 440 }} />
                                : <Empty description="No pending schedule" ></Empty>}
                        </div>
                    </Col>
                </Row>
                <Modal
                    width={350}
                    title={null}
                    open={this.state.showCreateSchedule}
                    footer={null}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    destroyOnClose={true}
                >
                    <CreateSchedultPopup
                        selectedSchedule={this.state.selectedSchedule}
                        screendata={screendata} onComplete={() => {
                            this.setState({ showCreateSchedule: false })
                            this.reloadSchedules();
                        }}></CreateSchedultPopup>
                </Modal>
            </div >
        );
    }
}

const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerGet, requestServerPost, selectPage })(PublishingScheduleManagerPage);
